import {
	ICreatorContentsDetailsDB,
	ICreatorProfileDB,
	IRecommandCollaborationListDB,
	IRecommandCreatorListDB,
	IRecommendationsDB,
} from 'type/wconcepdb';

import { api } from './api';

export const creator_apis = {
	// recommand_apis

	getRecommendationList: async () => {
		const data = await api.get('api/creators/recommendations');
		return data.data as IRecommendationsDB[];
	},

	getRecommendationCreatorList: async (recommendationId: string, platform: string) => {
		const data = await api.get(
			`api/creators/recommendations/${recommendationId}?platform=${platform}`,
		);
		return data.data as IRecommandCreatorListDB;
	},

	// 	GET /api/creators/recommendations/{recommendationId}/collaborations?platform=
	// platform=["instagram", "youtube"]
	getCreatorCollaborationList: async (recommendationId: string, platform: string) => {
		const data = await api.get(
			`api/creators/recommendations/${recommendationId}/collaborations?platform=${platform}`,
		);
		return data.data as IRecommandCollaborationListDB;
	},

	//	GET /api/creators/recommendations/{recommendationId}/collaborations/{creatorPk}
	getCreatorProfile: async (recommendationId: string, creatorPk: string) => {
		const data = await api.get(
			`api/creators/recommendations/${recommendationId}/collaborations/${creatorPk}`,
		);
		return data.data as ICreatorProfileDB;
	},

	// GET /api/creators/recommendations/{recommendationId}/collaborations/{creatorPk}/contents/{contentPk}/details
	getCreatorContentsDetails: async (
		recommendationId: string,
		creatorPk: string,
		contentPk: string,
	) => {
		const data = await api.get(
			`api/creators/recommendations/${recommendationId}/collaborations/${creatorPk}/contents/${contentPk}/details`,
		);
		return data.data as ICreatorContentsDetailsDB;
	},

	//PUT /api/creators/recommendations/recommendationId/collaborations/creatorPk/memo
	// 	request
	// {
	//     "memo": ""
	// }
	// 	response
	// {
	//     "message": "Memo updated successfully"
	// }
	putCreatorMemo: async (recommendationId: string, creatorPk: string, memo: string) => {
		console.log('putCreatorMemo    :::   ', recommendationId, creatorPk, memo);
		const data = await api.put(
			`api/creators/recommendations/${recommendationId}/collaborations/${creatorPk}/memo`,
			{ memo },
		);
		return data.data as { message: string };
	},
};
